import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Grid, makeStyles } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import { ExerciseList } from './ExerciseList';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomButton from '../../shared/CustomButton';
import service from '../../../apis/service';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import { ErrorToast, notifySuccess } from '../../utils/Utils';
import { showProgress, getJourneyDetails } from '../../../redux/actions/DealershipActions';
import useAiExercise from '../hooks/useAiExercise';
import ShowProgress from '../../ui/Backdrop';

const style = {
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '527px',
  backgroundColor: '#F2F4F7',
  outline: 'none',
  '&:focus': {
    outline: 'none',
  },
  '&:focus-visible': {
    outline: 'none',
  },
};

const useStyle = makeStyles({
  headerConatiner: {
    width: '527px',
    height: '72px',
    padding: '24px 16px 24px 16px',
    background: 'white',
  },
  contentContainer: {
    width: '527px',
    height: '579px',
  },

  buttonContainer: {
    marginTop: 'auto',
    background: '#FFFFFF',
    width: '527px',
    height: '64px',
    border: '1px',
  },
});

export default function AddAiExercise({ isOpen, handleClose, journeyId, levelId }) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { fetchAiExercises, exercises, fetchDetails } = useAiExercise();
  const [data, setData] = React.useState({ levelId, exerciseIds: [] });

  React.useEffect(() => {
    fetchAiExercises(journeyId);
  }, [fetchAiExercises, journeyId]);

  const handleData = ({ target: { checked, value } }) => {
    setData((prev) => {
      const updatedExercises = checked
        ? [...new Set([...prev.exerciseIds, value])]
        : prev.exerciseIds.filter((item) => item !== value);
      return { ...prev, exerciseIds: updatedExercises };
    });
  };
  const addExercises = async (payload) => {
    dispatch(showProgress(true));
    try {
      await service.post(apiEndpoints.JOURNEY_ADD_AI_ROLEPLAY, payload);
      notifySuccess('Exercise added successfully');
      fetchDetails(levelId);
      // Fetch updated journey details from API
      if (journeyId) {
        const journeyResponse = await service.get(apiEndpoints.JOURNEY_BY_ID.replace('ID', journeyId), '');
        dispatch(getJourneyDetails('updateJourneyDetails', journeyResponse));
      }
    } catch (error) {
      ErrorToast(error);
    }
    handleClose();
    dispatch(showProgress(false));
  };

  const handleSave = () => {
    addExercises(data);
  };

  return (
    <div>
      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            className={classes.headerConatiner}
          >
            <Grid item>
              <CustomPopupText text="Add AI Exercise" fontSize="16px" fontWeight="600" color="#000" />
            </Grid>
            <Grid item>
              <Close onClick={handleClose} style={{ cursor: 'pointer' }} />
            </Grid>
          </Grid>

          <ExerciseList
            selected={data?.exerciseIds}
            exercises={exercises}
            className={classes.contentContainer}
            handleData={handleData}
          />

          <Grid container justifyContent="flex-end" style={{ height: '100%' }}>
            <Grid item className={classes.buttonContainer}>
              <Grid container direction="row" alignItems="center" justifyContent="flex-end" style={{ height: '100%' }}>
                <Grid item style={{ marginRight: '6px' }}>
                  <CustomButton label="Cancel" type="secondary" onClick={() => handleClose()} />
                </Grid>
                <Grid item style={{ marginRight: '6px' }}>
                  <CustomButton label="Save" type="primary" onClick={handleSave} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <ShowProgress />
        </Box>
      </Modal>
    </div>
  );
}
